// shouldShowAdminRole determines if an admin role should be shown in the list of roles from which
// the user is allowed to choose.
const shouldShowAdminRole = (rootScope, account, user, role) => {
  if (!!account.reseller_id) {
    // For reseller accounts, we only consider the 'reseller-admin' role, which we only want to
    // allow if the current user is a system admin.
    return role.value == 'reseller-admin' && rootScope.me.isSystemAdmin();
  }

  // Otherwise, for non-reseller-admin roles, always show the other admin roles if the current user
  // is a system admin OR the user being edited already has this role.
  return (role.value != 'reseller-admin') && (rootScope.me.isSystemAdmin() || _.contains(user.roles, role.value));
};

angular
.module('app.views')
.controller('UserFormController', function($rootScope, $scope, $location, $routeParams, $modalInstance, $filter, $modal, User, Config, account){
  $scope.isSaving = false;
  $scope.user = { role: 'standard-user' };
  $scope.userRoles = angular.copy(Config.userRoles);
  $scope.resetPasswordConfirmation = false;
  $scope.requiresVerification = false;
  $scope.requestPaymentConfirmation = false;
  $scope.formChange = false;
  $scope.confirmDowngradeOwner = { val: false};
  $scope.ownerErrorMessage = '',
  $scope.verifiedText = 'VERIFIED';
  $scope.pendingText = 'PENDING';
  $scope.pristineUser = { role: 'standard-user' };

  const addAdminRoles = (user) => {
    _.each(Config.adminRoles, (r) => {
      if (shouldShowAdminRole($rootScope, account, user, r)) {
        $scope.userRoles.push(r);
        return;
      }
    });
  }
  const removeOwnerRole = () => {
    const index = _.findIndex($scope.userRoles, (r) => r.value = 'owner');
    if (index > -1) {
      $scope.userRoles.splice(index, 1);
    }
  }

  $scope.isNew = !$routeParams.account_id;
  if (!$scope.isNew) {
     User.get({account_id: $routeParams.account_id, id: $routeParams.id})
      .$promise
      .then((res) => {
        $scope.user = res;
        addAdminRoles($scope.user);
        // Turn roles into role for convenience
        if ($scope.user.roles.length > 0) {
          $scope.user.role = $scope.user.roles[0];
        };
        $scope.pristineUser = angular.copy($scope.user);
      });
  } else {
    addAdminRoles($scope.user);
    removeOwnerRole();
  }

  $scope.isDowngradingOwner = function() {
    return $scope.pristineUser.role == 'owner' && $scope.user.role != 'owner'
  }
 
  $scope.sendPasswordReset = function() {
    if(!confirm('Are you sure you want to send a password reset link to this user?')){
      return;
    }
    User.passwordReset({account_id: $routeParams.account_id, id: $routeParams.id})
    $scope.resetPasswordConfirmation = true;
  }

  $scope.resendVerificationEmail = function() {
    if(!confirm('Are you sure you want to resend the verification email to this user?')){
      return;
    }
    return User.update(
      {account_id: $scope.user.account_id, id: $scope.user.id, requires_verification: true})
        .$promise
        .then((res) => {
          $scope.requiresVerification = true;
          $scope.user = res;
        })
  }

  $scope.sendPaymentRequest = function() {
    if(!confirm('Are you sure you want to send a payment request to this user?')){
      return;
    }
    return User.update(
      {account_id: $scope.user.account_id, id: $scope.user.id, request_payment_email: true})
        .$promise
        .then((res) => {
          $scope.requestPaymentConfirmation = true;
          $scope.user = res;
        })
  }

  $scope.addAuthorizedAccount = function() {
    var modalInstance = $modal.open({
      template: require('./add_authorized_account.html'),
      controller: 'AddAuthorizedAccountController',
      size: 'md',
      backdrop: 'static'
    });
    modalInstance.result.then((res) => {
      $scope.user = res;
      $scope.user.role = res.roles[0];
    });
  };

  $scope.deleteAuthorizedAccount = function(a) {
    if (!confirm("Are you sure you want to delete this authorized account?")) {
      return;
    } 

    var ids = _.pluck($scope.user.authorized_accounts, 'id');
    if (ids.length == 0) {
      ids = [$scope.user.account_id];
    }

    var index = ids.indexOf(a.id);
    ids.splice(index, 1);

    return User.update(
      {account_id: $scope.user.account_id, id: $scope.user.id, authorized_account_ids: ids})
        .$promise
        .then((res) => {
          $scope.user = res;
          $scope.user.role = res.roles[0];
        })
  };

  $scope.$watch('user', function() {
    $scope.formChange = !angular.equals($scope.user, $scope.pristineUser)
    $scope.roleChange = $scope.user.role != $scope.pristineUser.role;
    $scope.emailChange = $scope.pristineUser.email != $scope.user.email;
    $scope.upgradingRole = $scope.pristineUser.role != 'owner' && $scope.user.role == 'owner';
  }, true)

  $scope.checkPendingEmailChange = function() {
    if($scope.user.pending_email_update != $scope.pristineUser.pending_email_update) {
      $scope.pendingText = 'UNVERIFIED'
      document.getElementById('pending-text').style.backgroundColor = '#777';
    } else {
      $scope.pendingText = 'PENDING'
      document.getElementById('pending-text').style.backgroundColor = '#EEAD4D';
    }
  }

  $scope.isVerified = function() {
    if($scope.user.email != $scope.pristineUser.email) {
      $scope.verifiedText = 'UNVERIFIED';
      document.getElementById('verified-text').style.backgroundColor = '#777';
    } else if ($scope.user.email == $scope.pristineUser.email) {
      $scope.verifiedText = 'VERIFIED';
      document.getElementById('verified-text').style.backgroundColor = '#1CA6A0';
    }
  };

  $scope.ownerError = function() {
    if($scope.user.role == 'owner' && $scope.user.authorized_accounts.length > 1){
      $scope.ownerErrorMessage = "This email is associated with multiple BoxCast accounts. Users who are authorized to access multiple accounts are not able to be assigned the Owner role."
      return true
    } else if ($scope.roleChange && $scope.user.role == 'owner' && !$scope.user.is_verified) {
      $scope.ownerErrorMessage = "Users with an unverified email address cannot be made the Owner of an account. Please have the user verify their email or assign the Owner role to a different user."
      return true
    }
    return false
  };

  $scope.ok = function() {
    $scope.isSaving = true;

    if($scope.user.pending_email_update) {
      $scope.user.email = $scope.user.pending_email_update
    }

    // Change "role" into "roles"
    if ($scope.user.role && $scope.user.role !== '') {
      $scope.user.roles = [$scope.user.role];
    } else {
      $scope.user.roles = ['standard-user'];
    }
    delete $scope.user.role;

    // Force lowercase e-mail for dupe checking
    $scope.user.email = $filter('lowercase')($scope.user.email);

    if ($scope.isNew) {
      $scope.user.account_id = $routeParams.id;
      return User.save($scope.user,
        u=> $modalInstance.close(u),
        err=> $scope.isSaving = false);
    } else {
      if($scope.user.pending_email_update){
          $scope.user.email = $scope.user.pending_email_update
      }
      if($scope.pristineUser.role == 'owner' && $scope.user.roles[0] === 'owner'){
        delete $scope.user.roles;
      }
      $scope.user.account_id = $routeParams.account_id;
      return User.update($scope.user,
        u=> $modalInstance.close(u),
        err=> $scope.isSaving = false);
    }
  };

  $scope.delete = function() {
    if ($scope.user.id == $rootScope.me.id) {
      alert('You cannot delete your own user.');
      return;
    }
    if (!confirm('Are you sure you want to delete this user? The action cannot be undone.')) {
      return;
    }
    $scope.isSaving = true;
    User.delete($scope.user,
      ok=> {
        $modalInstance.close(ok)
        history.go(-1);
      },
      err=> {
        console.error(err);
        alert('Unable to delete: ' + err);
        $scope.isSaving = false;
      }
    );
  };

  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});


// WEBPACK FOOTER //
// ./views/user/user_form_controller.js